import "./addnewcontact.css";

import { useSnackbar } from "notistack";
import axios from "axios";
import { useReducer, useState } from "react";
import { useSelector } from "react-redux";
import IsLoading from "../../../../../../IsLoading";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

export default function AddNewContact({ setOpenModal }) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [errors, setErrors] = useState({});
  const [contactData, setContactData] = useReducer(
    (state, updates) => {
      return { ...state, ...updates };
    },
    {
      fullName: "",
      contactType: "Customer",
      phoneNumber: "",
      emailAddress: "",
      company: "",
      status: "Active",
      address: "",
      city: "",
      notes: "",
    },
  );

   const companyData = useSelector(
      (state) => state.clientFunction?.companiesDB?.clientData,
    ); 

  const payload = {
    clientId: companyData?.clientId,
    profile: {
      fullName: contactData.fullName,
      photo: "",
      type: contactData.contactType,
      status: contactData.status,
    },

    contact: {
      phone: {
        primary: contactData.phoneNumber,
        secondary: "",
      },

      email: {
        primary: contactData.emailAddress,
        secondary: "",
      },

      address: {
        street: contactData.address,
        city: contactData.city,
        state: "",
        country: "Nigeria",
        postalCode: "",
      },

      company: {
        name: contactData.company,
        department: "",
        position: "",
        website: "",
      },
    },

    business: {
      customerId: "",
      supplierId: "",
      employeeId: "",
      accountNumber: "",
      balance: 0,
      creditLimit: 0,
      currency: "NGN",
    },

    activity: {
      totalTransactions: 0,
      totalSales: 0,
      totalPurchases: 0,
      lastTransaction: null,
      lastContacted: null,
    },

    preferences: {
      favorite: false,
      allowEmail: true,
      allowSms: true,
      allowCalls: true,
    },

    notes: {
      description: contactData.notes,
      attachments: [],
    },

    audit: {
      createdBy: "",
      updatedBy: "",
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      deletedAt: null,
      isDeleted: false,
    },
  };

  console.log("CONTACT TO FETCH", companyData?.clientId);
  const apiPostNewContact = async () => {
    setLoading(true);

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/contacts/new_contact/add`,
        payload,
        {
          timeout: 30000,
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      const { status, message, newContact } = data;

      console.log(status, message, newContact);
      switch (status) {
        case 201:
          enqueueSnackbar(message, {
            variant: "success",
            autoHideDuration: 3000,
          });

          // navigateTo("/create_new_account/queries?page=1");
          break;

        case 408:
        case 409:
        case 400:
        case 401:
        case 403:
        case 404:
        case 422:
          enqueueSnackbar(message, {
            variant: "error",
            autoHideDuration: 3000,
          });
          break;

        default:
          enqueueSnackbar(
            message || "An unexpected server response was received.",
            {
              variant: "warning",
              autoHideDuration: 3000,
            },
          );
      }
    } catch (error) {
      if (!error.response) {
        enqueueSnackbar(
          "Unable to connect to the server. Check your internet connection.",
          {
            variant: "error",
          },
        );
      } else if (error.code === "ECONNABORTED") {
        enqueueSnackbar("Request timed out. Please try again.", {
          variant: "error",
        });
      } else if (error.response.status >= 500) {
        enqueueSnackbar("The server encountered an error.", {
          variant: "error",
        });
      } else {
        enqueueSnackbar(error.response.data?.message || error.message, {
          variant: "error",
        });
      }

      console.error("POST /new_client/register", error?.code || "REQUEST_FAILED");
    } finally {
      setLoading(false);
      setOpenModal(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!contactData.fullName.trim()) newErrors.fullName = true;
    if (!contactData.phoneNumber.trim()) newErrors.phoneNumber = true;
    if (!contactData.company.trim()) newErrors.company = true;
    if (!contactData.address.trim()) newErrors.address = true;
    if (!contactData.city.trim()) newErrors.city = true;
    if (!contactData.notes.trim()) newErrors.notes = true;

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  return (
    <>
      {loading && <IsLoading />}
      {/* Profile Image */}
      <div className="addNewContWrap">
        <div className="addNewContactCont" onClick={(e) => e.stopPropagation()}>
          <div className="fx-jb">
            <div className="fx-ac space1">
              <div className="logo-preview">
                <span className="fs6">👤</span>
              </div>

              <div className="fg1 fx-cl fx-jb space1">
                <h4 className="fs4 fw600">Contact Photo</h4>

                <p className="fs2 cb">
                  Upload an optional profile image (Max. 4 MB)
                </p> 
              </div>
            </div>
            <button
              className="btnCloseContacts fx-ac fx-jc"
              onClick={() => setOpenModal(false)}
            >
              <CloseOutlinedIcon style={{ fontSize: "3.1rem" }} />
            </button>
          </div>

          {/* Contact Details */}
          <div className="g g2 space1 form-grid">
            <div className="field">
              <label>Full Name</label>

              <input
                type="text"
                placeholder="Enter full name"
                className={errors.fullName ? "input-error" : ""}
                value={contactData.fullName}
                onChange={(event) => {
                  setContactData({
                    fullName: event.target.value,
                  });
                  setErrors((prev) => ({ ...prev, fullName: false }));
                }}
              />
            </div>

            <div className="field">
              <label>Contact Type</label>

              <select
                value={contactData.contactType}
                onChange={(event) =>
                  setContactData({
                    contactType: event.target.value,
                  })
                }
              >
                <option>Customer</option>
                <option>Supplier</option>
                <option>Employee</option>
                <option>Other</option>
              </select>
            </div>

            <div className="field">
              <label>Phone Number</label>

              <input
                type="tel"
                placeholder="+234..."
                className={errors.phoneNumber ? "input-error" : ""}
                value={contactData.phoneNumber}
                onChange={(event) => {
                  setContactData({
                    phoneNumber: event.target.value,
                  });
                  setErrors((prev) => ({ ...prev, phoneNumber: false }));
                }}
              />
            </div>

            <div className="field">
              <label>Email Address</label>

              <input
                type="email"
                placeholder="example@email.com"
                value={contactData.emailAddress}
                onChange={(event) =>
                  setContactData({
                    emailAddress: event.target.value,
                  })
                }
              />
            </div>

            <div className="field">
              <label>Company</label>

              <input
                type="text"
                placeholder="Company name"
                className={errors.company ? "input-error" : ""}
                value={contactData.company}
                onChange={(event) => {
                  setContactData({
                    company: event.target.value,
                  });
                  setErrors((prev) => ({ ...prev, company: false }));
                }}
              />
            </div>

            <div className="field">
              <label>Status</label>

              <select
                value={contactData.status}
                onChange={(event) =>
                  setContactData({
                    status: event.target.value,
                  })
                }
              >
                <option>Active</option>
                <option>Inactive</option>
              </select>
            </div>

            <div className="field">
              <label>Address</label>

              <input
                type="text"
                placeholder="Street address"
                className={errors.address ? "input-error" : ""}
                value={contactData.address}
                onChange={(event) => {
                  setContactData({
                    address: event.target.value,
                  });
                  setErrors((prev) => ({ ...prev, address: false }));
                }}
              />
            </div>

            <div className="field">
              <label>City</label>

              <input
                type="text"
                placeholder="City"
                className={errors.city ? "input-error" : ""}
                value={contactData.city}
                onChange={(event) => {
                  setContactData({
                    city: event.target.value,
                  });
                  setErrors((prev) => ({ ...prev, city: false }));
                }}
              />
            </div>
          </div>

          {/* Notes */}
          <div className="field textarea-field">
            <label>Notes</label>

            <textarea
              className={errors.notes ? "input-error" : ""}
              placeholder="Add any additional information about this contact..."
              value={contactData.notes}
              onChange={(event) => {
                setContactData({
                  notes: event.target.value,
                });
                setErrors((prev) => ({ ...prev, notes: false }));
              }}
            />

            <span className="word-limit">Maximum 250 words</span>
          </div>

          {/* Footer */}
          <div className="fx-je space modal-footer">
            <button className="btn-light">Cancel</button>
            <button
              className="btn-dark"
              onClick={() => {
                if (validateForm()) {
                  apiPostNewContact();
                }
              }}
            >
              Save Contact
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
